<template>
<div class="card block-news-height">
        <div class="card-body p-element-page">
            <div class="float-end">           
            <NuxtLink :to="routePath({name: category})">
               <span class="text-muted font-size-13">
                   POGLEDAJ SVE
               </span>
            </NuxtLink>                 
            </div>
            <NuxtLink :to="routePath({name: category})">
              <div class="card-title bc-title mb-4 font-size-13 text-uppercase">{{ category }}</div>
           </NuxtLink>
           <hr>
            <ol class="activity-feed mb-0 ps-2" data-simplebar >               
                <li class="feed-item" v-for="news in itemsNewspapers" :key="news.id">
                    <!-- nova vest: slug; stara vest bez sluga: link iz naslova (stari nacin) -->
                    <NuxtLink :to="routePath({name:`${category}-title`, params:{title: news.slug || $srbTolat.srbTolat(news.title)}})">
                      <p class="mb-1 font-size-16 text-dark">                       
                          {{ news.title }}
                       </p>
                       <p class="mt-0 mb-0 text-primary">                       
                         {{  displayDate(news.date_newspaper) }}
                       </p>
                    </NuxtLink>             
                </li>               
            </ol>
        </div>
    </div>
</template>

<script setup>

const routePath = useRoutePath()

const { $srbTolat } = useNuxtApp()

 
const props = defineProps({
    
newspapers:{
   type: Array, 
   default: []
 },
 category_id: Number,
 category: String,
  })
const itemsNewspapers = computed(() => {
  const items = props.newspapers || []
  const catId = props.category_id
  return items
    .filter(x => x?.newspaper_category_id == catId)
    .slice(0, 7)
})

const displayDate = (date) => {

if (!date) return ''
  const d = String(date).split(/[T ]/)[0].replaceAll('-', '.')
  return d.endsWith('.') ? d : d + '.'

}

</script>

<style>

</style>
